module.exports = __webpack_public_path__ + "img/039.3914c79c.png";